import { PlayerSeatDto } from '@/services/table/tableState';
import { useMemo } from 'react';

const useAvailableActions = (playerSeat?: PlayerSeatDto, isActingPlayer?: boolean) => {
  return useMemo(() => {
    const availableActions = isActingPlayer
      ? playerSeat?.availableActions!
      : {
          canFold: playerSeat?.preActionsAvailable && !!playerSeat?.preActionsAvailable.foldCheck,
          canCheck:
            playerSeat?.preActionsAvailable &&
            !!playerSeat?.preActionsAvailable.checkCall &&
            playerSeat?.preActionsAvailable.checkCall?.amount === undefined,
          canRaise: playerSeat?.preActionsAvailable && !!playerSeat?.preActionsAvailable.betRaise,
          canBet: false,
          canCall:
            playerSeat?.preActionsAvailable &&
            !!playerSeat?.preActionsAvailable.checkCall &&
            playerSeat?.preActionsAvailable.checkCall?.amount !== undefined,
          canStandPatOrDiscard: playerSeat?.preActionsAvailable && !!playerSeat?.preActionsAvailable.standPatOrDiscard,
          canPostBringIn: false,
          canCompleteBetOrRaise: false,
          canComplete: false,
        };

    const preAmount = !isActingPlayer ? playerSeat?.preActionsAvailable?.checkCall?.amount : undefined;

    return {
      ...availableActions,
      preAmount,
      preActionLabels: playerSeat?.preActionsAvailable || {},
    };
  }, [isActingPlayer, playerSeat?.availableActions, playerSeat?.preActionsAvailable]);
};

export default useAvailableActions;
